import React from 'react';
import styled from 'styled-components';
import {COLORS, SIZES} from '../styleVars';
import {Typography} from '../typography/Typography';

const Container = styled.div`
  padding: 0.75rem 0.5rem;
  width: 100%;
  min-height: 5rem;
  display: flex;
  background-color: ${COLORS.lightRed};
  border-radius: 0.25rem;
  justify-content: center;
`;

const MessageContainer = styled.div`
  margin-left: 0.5rem;
  flex: 1;
`;

const Svg = styled.svg`
  fill: currentColor;
  width: 1em;
  height: 1em;
  display: inline-block;
  font-size: ${SIZES[24]};
  color: ${COLORS.red};
  flex-shrink: 0;
`;

interface ErrorProps {
  /**
   * Unique Name of the Error
   */
  errorCode: string;
  /**
   * Declarative Message to inform the user about the reason why this error is thrown
   */
  errorMessage: string;
}

const Error: React.FC<ErrorProps> = ({errorCode, errorMessage}) => {
  return (
    <Container>
      <Svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
        <path d='M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z' />
      </Svg>
      <MessageContainer>
        <Typography variant='body-strong'>{errorCode}</Typography>
        <br />
        <Typography variant='body1'>{errorMessage}</Typography>
      </MessageContainer>
    </Container>
  );
};

export {Error};
